import { FormProvider, UseFormReturn } from "react-hook-form";

import { FilterValues } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/filter-schema";
import PreferencesFilter from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/preferences-filter";
import { SavedSearches } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/saved-searches";
import { useActiveSelectionValue } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/use-active-selection-value";
import { useAuth } from "@/stores/use-auth";

export interface SavedSearchesAndPreferencesProps {
  form: UseFormReturn<FilterValues>;
  filterDefaults: FilterValues;
}

const SavedSearchesAndPreferences: React.FC<
  SavedSearchesAndPreferencesProps
> = ({ form, filterDefaults }) => {
  const activeSelection = useActiveSelectionValue(form);
  const { user } = useAuth();

  return (
    <section className="flex flex-col items-start pb-4 mb-4 border-b border-line-faint">
      <FormProvider {...form}>
        <h2 className="text-base font-bold mb-2">
          Saved Searches & Preferences:
        </h2>
        <div className="w-full flex flex-col">
          <PreferencesFilter
            form={form}
            filterDefaults={filterDefaults}
            activeSelection={activeSelection}
          />
          {user && (
            <SavedSearches
              userId={user.id}
              form={form}
              filterDefaults={filterDefaults}
              activeSelection={activeSelection}
            />
          )}
        </div>
      </FormProvider>
    </section>
  );
};

export default SavedSearchesAndPreferences;
